import "./Compliance.css"
import { useParams } from "react-router-dom";
import ManagerSubHeaderLinks from "../../components/managerSubHeaderLinks/ManagerSubHeaderLinks.jsx";
import { useEffect, useState } from "react";
import ComplianceModal from "../../components/complianceModal/ComplianceModal.jsx";
import UserShortProfile from "../../components/userShortProfile/UserShortProfile.jsx";
import LoadingSpinner from "../../components/loadSpinner/LoadingSpinner.jsx";
import DefaultProfileImage from '../../medias/images/default.jpg'
import { requestGetCompliancesByUser } from "../../services/wisdomServices/complianceService";
import { getUserInformations } from "../../services/wisdomServices/userService";
import { requestGetImagesFromBucket } from "../../services/wisdomServices/trackingService";
import { Tag } from "primereact/tag";
import { Button } from "primereact/button"; 
import WisdomDataTable from "../../components/dataTable/WisdomDataTable.jsx";
import { extractAndFormatDate } from "../../utils/helper/extractAndFormatDate";
/**
 * @function UserCompliances
 * @returns {JSX.Element} - user compliances table
 */
function UserCompliances(){
    const params = useParams()
    const [compliance, setCompliance] = useState('')
    const [compliances, setCompliances] = useState([])
    const [openModal, setOpenModal] = useState(false)
    const [page, setPage] = useState(1);
    const [rows, setRows] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [first, setFirst] = useState(0);
    let [euser,setEuser] = useState(0);
    let [loading, setLoading] = useState(true)

    const getStatus = (status) => {
        switch (status){
            case "open":
                return "info"
            
            case "closed":
                return "warning"

            default:
                return "success"
        }
    }

    const statusBodyTemplate = (rowData) => {
        const status = rowData.isOpen ? "open" : "closed"
        return(
            <Tag  value={status} severity={getStatus(status)} />
        )
    }

    const detailsBodyTemplate = (rowData) => (
        <Button 
            icon="pi pi-id-card" 
            iconPos="right" 
            rounded 
            text 
            raised 
            severity="info" 
            onClick={() => openComplianceDetails(rowData)} 
        />
    )

    const updatedAtColumnsTemplate = (rowData) => {
        return extractAndFormatDate(rowData.updatedAt)
    }

    const createDateColumnsTemplate = (rowData) => {
        return extractAndFormatDate(rowData.createDate)
    }

    const columns = [
        {
            field: "user",
            header: "User"
        },
        {
            field: "complianceType",
            header: "Compliance Type",
            
        },
        {
            field: "project",
            header: "Project",
           
        },
        {
            field: "manager",
            header: "Manager",
           
        },
        {
            header: "Create Date",
            body: createDateColumnsTemplate,
            
        },
        {
            header: "Status",
            body: statusBodyTemplate
            
        },
        {
            header: "Updated At",
            body: updatedAtColumnsTemplate,
            
        },
        {
            field: "updatedBy",
            header: "Updated By",
           
        },
        {
            header: "Detail",
            body: detailsBodyTemplate
        },
        
    ];

    /**
     * @async
     * @function getCompliances
     * @description - fetches all compliance records for the selected user
     */
    async function getCompliances(pageNumber = 1, pageSize = rows){
        try {
            let response = await requestGetCompliancesByUser(params.employeeId, pageNumber, pageSize)
            const { data, pagination } = response;
            setCompliances(data)
            setTotalRecords(pagination.totalResults);
            
        } catch (error) {
            console.error(error)
        }
    }

    const onPageChange = (event) => {
        const newPage = event.page + 1; 
        const newRows = event.rows;

        setPage(newPage);
        setRows(newRows);
        setFirst(event.first);

        getCompliances(newPage, newRows);
    };

    /**
     * @async
     * @function closeModal
     * @description - closes the modal and refreshes compliance data
     */
    async function closeModal(){
        setOpenModal(false)
        await getCompliances()
    }
    /**
     * @async
     * @function closeModalByClick
     * @description - closes the modal via click action and refreshes data
     */
    async function closeModalByClick(){
        setOpenModal(false)
        await getCompliances()
    }
    /**
     * @function closeAfterSaving
     * @description - closes the modal after saving changes
     */
    async function closeAfterSaving(){
        setOpenModal(false)
        await getCompliances()
    }
    /**
     * @function openComplianceDetails
     * @param {Object} e 
     * @description - opens the compliance detail modal
     */
    function openComplianceDetails(rowData){ 
        setCompliance(rowData)
        setOpenModal(true)
    }


    /**
     * @async
     * @function getUser
     * @description - fetches user profile data and profile image
     */
    const getUser = async () => {
        let user = await getUserInformations(params.employeeId)
        if(!user?.image){
            user.image = DefaultProfileImage
        }else{
            const blob = await requestGetImagesFromBucket(user.id, user.image, "profile")
            user.image = URL.createObjectURL(blob)
        }

        setEuser(user);
        setLoading(false)
    }

    useEffect(() => {
        const fetchData = async() => {
            try {

              await getCompliances()
              await getUser()
              setLoading(false)
            } catch (error) {
              console.error("ERROR: ", error)
            }
          }
          
          fetchData()
    }, [])

    return(
        <div className="manager-view-user-compliance">
            {loading && <LoadingSpinner />}
            {!loading && (
                <div className="manager-view-user-compliance-main">
                    <div className="my-dashboard-header">
                        <UserShortProfile
                            employeeName={euser.firstName + ' ' + euser.lastName}
                            employeePronoun={euser.pronoun}
                            employeeDesignation={euser.jobDescription}
                            employeeID={euser.id}
                            employeeUsername={euser.username}
                            employeeLocation={euser.city}
                            employeePicture={euser.image}
                            employeeDisabled={euser.isDisabled}
                            employeeContractEndDate={euser.contractEndDate}
                            employeeDepartment={euser.department}
                            employeeIdvStatus={euser.trolleyIdvStatus}
                            employeePersonalEmail={euser.personalEmail}
                            showManagerLinks={true}
                        />
                    </div>
                    <div className="manager-view-user-compliance-table">
                        <h1 style={{margin:"16px 0"}}>Compliance Items</h1>
                        <WisdomDataTable 
                            data={compliances} 
                            columns={columns} 
                            rows={rows}
                            totalRecords={totalRecords}
                            onPage={onPageChange}
                            first={first}
                        />
                    </div>
                </div>
            )}
            <ComplianceModal 
                compliance={compliance} 
                onCloseModal={closeModal} 
                onCloseModalByClick={closeModalByClick} 
                onCloseAfterSaving={closeAfterSaving}
                open={openModal}
            />
        </div>
    )
}

export default UserCompliances;